import React from 'react';
import { styled } from 'styled-components';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import { ICON_SETTLEMENT_REQUEST_NOTICE } from 'assets/icons';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  width: 100%;
  border-radius: 12px;
  background-color: #f7f7f8;
`;

const RequestDescription = () => {
  return (
    <Container>
      <img
        src={ICON_SETTLEMENT_REQUEST_NOTICE}
        alt="icon settlement request notice"
      />
      <Column gap="4px" align="flex-start">
        <Text color="#1b1c1e" weight={600}>
          지급 요청 내역이란?
        </Text>
        <Text color="#46474C" size="13px" weight={400}>
          {`회차별 정산 내역을 묶어 일괄 지급 요청을 진행하시면, 해당 묶음 단위로
          '지급 내역'이 생성됩니다.`}
        </Text>
      </Column>
    </Container>
  );
};

export default RequestDescription;
